import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';

class SpecialDishItem extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = { 
            id: props.id,
            itemname: props.item,
            custom: props.custom,
            customData: props.customData,
            inCart: 'N',
            addButton: 'Y',
            cartCount: '0',
            ItemAddOn: false,
        };
    }

    handleClickAddToCart = (id,custom)=>{
        
        let cartRES = localStorage.getItem('cartRES');
        let resID = localStorage.getItem('REST2');
        if(cartRES === null || cartRES==='{}')
            localStorage.setItem('cartRES',resID);

        let cartTotalCount = 0;
        let inCart = 'N';
        let addButton = 'Y';
        let cartCount = 0;

        var addToObject = function (obj, key, value, index) {

            // Create a temp object and index variable
            var temp = {};
            var i = 0;
        
            // Loop through the original object
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
        
                    // If the indexes match, add the new item
                    if (i === index && key && value) {
                        temp[key] = value;
                    }
        
                    // Add the current item in the loop to the temp obj
                    temp[prop] = obj[prop];
        
                    // Increase the count
                    i++;
        
                }
            }
        
            // If no index, add to the end
            if (!index && key && value) {
                temp[key] = value;
            }
        
            return temp;
        
        };
                
        let cart = localStorage.getItem('cartData');
        
        var that = this;
        if (cart === null) {
            var a = {[id+'~~**~~'+custom]: 1};
            /*console.log('typeof testObject: ' + typeof a);
            for (var prop in a) {
                console.log('  ' + prop + ': ' + a[prop]);
            }*/
            
            localStorage.setItem('cartData',JSON.stringify(a));

            let inCart = 'Y';
            let addButton = 'N';
            let cartCount = 1;

            that.setState({ inCart:inCart, addButton:addButton, cartCount:cartCount});
            this.props.inCartCallBack2();
            /*var retrievedObject = localStorage.getItem('cartData');
            console.log('typeof retrievedObject: ' + typeof retrievedObject);
            console.log('Value of retrievedObject: ' + JSON.parse(retrievedObject));*/
        }
        else
        {
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function(key) {
                //console.log(key);
                //console.log(cartData[key]);
                let cart_id = key.split('~~**~~');
                if(cart_id[0]==id)
                {
                    cartTotalCount += cartData[key];
                }
    
                if(cart_id[0]==id && custom==cart_id[1])
                {
                    delete cartData[key];
                }
            });
            cartTotalCount += 1;

            cartData = addToObject(cartData, [id+'~~**~~'+custom], 1);
            localStorage.setItem('cartData', JSON.stringify(cartData));
            //console.log(localStorage.getItem('cartData'));

            let inCart = 'Y';
            let addButton = 'N';
            let cartCount = 1;
            that.setState({ inCart:inCart, addButton:addButton, cartCount:cartTotalCount});
            this.props.inCartCallBack2();
        }    
    }

    handleClickIncreement = (id,custom,cartCount)=>{

        let cartTotalCount = 0;
        cartCount = cartCount + 1;
        let cart = localStorage.getItem('cartData');
        var that = this;
        var cartData = JSON.parse(cart);
        Object.keys(cartData).forEach(function(key) {
            //console.log(key);
            //console.log(cartData[key]);
            let cart_id = key.split('~~**~~');
            if(cart_id[0]==id)
            {
                cartTotalCount += cartData[key];
            }

            if(cart_id[0]==id && custom==cart_id[1])
            {
                cartData[key] = cartCount;
            }
        });
        cartTotalCount += 1;

        localStorage.setItem('cartData', JSON.stringify(cartData));

        let inCart = 'Y';
        let addButton = 'N';
        cartCount = cartCount;
        that.setState({ inCart:inCart, addButton:addButton, cartCount:cartTotalCount});
        this.props.inCartCallBack2();
    }

    handleClickDecreement = (id,custom,cartCount)=>{
        
        cartCount = (cartCount!=0)?cartCount - 1:0;
        let cart = localStorage.getItem('cartData');
        var that = this;
        var cartData = JSON.parse(cart);
        Object.keys(cartData).forEach(function(key) {
            //console.log(key);
            //console.log(cartData[key]);
            let cart_id = key.split('~~**~~');
            if(cart_id[0]==id && custom==cart_id[1])
            {
                if(cartCount==0)
                    delete cartData[key];
                else
                    cartData[key] = cartCount;
            }
        });

        localStorage.setItem('cartData', JSON.stringify(cartData));
        cart = localStorage.getItem('cartData');
        if(cart === null || cart ==='{}')
        {
            localStorage.removeItem('cartRES');
            localStorage.removeItem('cartInstructions');
            localStorage.removeItem("cartData");
        }

        let inCart = (cartCount==0)?'N':'Y';
        let addButton = (cartCount==0)?'Y':'N';
        cartCount = cartCount;
        that.setState({ inCart:inCart, addButton:addButton, cartCount:cartCount});
        this.props.inCartCallBack2();
    }
   
    handleClickGetCustom = (id) => {
        
        let cartRES = localStorage.getItem('cartRES');
        let resID = localStorage.getItem('REST2');
        if(cartRES === null || cartRES==='{}')
            localStorage.setItem('cartRES',resID);

        //console.log(id);
        //console.log(custom);
        //console.log(customData);
        $('#ModalCustomData').modal('show');
    }    

    handleClickGetItemCustomSelected = (id,inputTAGS) => {
        //console.log(inputTAGS);
        var checkedCustom = '';
        if(inputTAGS!='')
        {
            var tags2 = inputTAGS.split('|');
            if(tags2!='')
            {
                jQuery.each( tags2, function( i, val ) {
                    var val2 = val.split('~');
                    var name2 = 'chkcustomdat_'+ val2[1] +'[]';
                    $.each($("input[name='"+name2+"']:checked"), function(){            
                        //checkedCustom.push($(this).val());
                        checkedCustom += $(this).val()+'|';
                    });
                });
            }
        }
        var custom = checkedCustom!=''?checkedCustom.substring(0, checkedCustom.length-1):'';
        //console.log(custom);
        this.handleClickAddToCart(id,custom);
    }

    handleClickGetCustomIncreement = (id,cartCount) => {
        $('#ModalCartExist').modal('show');
    }

    handleClickGetCustomChooseNew = (id) => {
        $('#ModalCustomData').modal('show');
    }
    
    handleClickGetCustomRepeat = (id,cartCount) => {

        let lastItemEntryCount = 0;
        let cart = localStorage.getItem('cartData');
        var that = this;
        var cartData = JSON.parse(cart);
        let lastItemEntry = '';
        Object.keys(cartData).forEach(function(key) {
            //console.log(key);
            //console.log(cartData[key]);
            let cart_id = key.split('~~**~~');
            if(cart_id[0]==id)
            {
                lastItemEntry = cart_id[1];
                lastItemEntryCount = cartData[key];
            }
        });

        let custom = lastItemEntry;
        this.handleClickIncreement(id,custom,lastItemEntryCount);
    }
    
    handleClickGetCustomDecreement = (id,cartCount) => {
        
        let cart = localStorage.getItem('cartData');
        var that = this;
        var cartData = JSON.parse(cart);
        let ItemEntryCount = 0;
        let lastItemEntryCount= 0;
        let lastItemEntry = '';
        Object.keys(cartData).forEach(function(key) {
            //console.log(key);
            //console.log(cartData[key]);
            
            let cart_id = key.split('~~**~~');
            if(cart_id[0]==id)
            {
                ItemEntryCount = ItemEntryCount + 1;
                lastItemEntry = cart_id[1];
                lastItemEntryCount = cartData[key];
            }
        });

        let custom = lastItemEntry;
        if(ItemEntryCount=='1')
            this.handleClickDecreement(id,custom,lastItemEntryCount);
        else    
            $('#ModalMultiCartExist').modal('show');
    }

    componentWillMount() {
        let inCart = 'N'; //this.state.inCart;
        let addButton = 'Y'; //this.state.addButton;
        let cartCount = 0; //this.state.cartCount;

        let currentITEM = this.state.id;
        //console.log(localStorage.getItem('cartData'));

        var that = this;
        let cart = localStorage.getItem('cartData');
        if (cart !== null) {
            let cartData = JSON.parse(cart);
            //console.log(cartData)
            
            Object.keys(cartData).forEach(function(key) {
                //console.log(key);
                //console.log(cartData[key]);
                let id = key.split('~~**~~');
                if(id[0]==currentITEM)
                {
                    inCart = 'Y';
                    addButton = 'N';
                    cartCount += cartData[key];
                }

                that.setState({ inCart:inCart, addButton:addButton, cartCount:cartCount});
        });
            
            // console.log(Object.keys(cart));
            //console.log(JSON.parse(cart));
            //let inCart = 'Y';
        }
    }
 
    render() { 

        //localStorage.removeItem("cartData");
        //console.log(localStorage.getItem("cartData"));
        let inCart = this.state.inCart;
        let addButton = this.state.addButton;
        let cartCount = this.state.cartCount;
        let currentITEM = this.state.id;
        let inputTAGS = ''; //[];
 
        return(
                <div>
                    <div className="aditions" >
                        {this.state.custom=='N' && <button style={{ display: addButton=='N' ? "none" : "block" }} className="btn btn-primary add" onClick={()=>{this.handleClickAddToCart(this.state.id,this.state.custom)}}>ADD</button>}
                        {this.state.custom=='Y' && <button style={{ display: addButton=='N' ? "none" : "block" }} className="btn btn-primary add" onClick={()=>{this.handleClickGetCustom(this.state.id)}}>ADD</button>}
                        <div className="openned" style={{ display: addButton=='N' ? "block" : "none" }} >
                            {this.state.custom=='N' && <button onClick={()=>{this.handleClickDecreement(this.state.id,this.state.custom,cartCount)}}> - </button>}
                            {this.state.custom=='Y' && <button onClick={()=>{this.handleClickGetCustomDecreement(this.state.id)}}> - </button>}
                                <input type="text" className="round-circle" value={cartCount} readOnly />
                            {this.state.custom=='N' && <button onClick={()=>{this.handleClickIncreement(this.state.id,this.state.custom,cartCount)}}> + </button>}
                            {this.state.custom=='Y' && <button onClick={()=>{this.handleClickGetCustomIncreement(this.state.id)}}> + </button>}
                        </div>
                    </div>
                    {this.state.custom=='Y' && this.state.customData!='' &&
                        <div>
                            <div className="modal fade modalbox" id="ModalCustomData" tabIndex="-1" role="dialog">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">{this.state.itemname}</h5>
                                            <Link to="javascript:;" data-dismiss="modal">Close</Link> 
                                        </div>
                                        <div className="modal-body p-0">
                                            {
                                                this.state.customData.map(addon=>{
                                                    //console.log(addon.CUSTOMID);
                                                    //console.log(addon.CUSTOMNAME);
                                                    let inputTYPE = addon.TYPE=='INC'?'checkbox':'radio';
                                                    inputTAGS += inputTYPE+'~'+addon.CUSTOMID+'|';
                                                    //inputTAGS.push(inputTYPE+'~'+addon.CUSTOMID);
                                                    //console.log(inputTAGS);
                                                    return(
                                                        <div key={addon.CUSTOMID}>
                                                            <div className="section full ">
                                                                <div className="section-title">{addon.CUSTOMNAME}</div>
                                                            </div>
                                                            <div className="input-list">
                                                                {
                                                                    addon.DET.map(addon2=>{
                                                                        //console.log(addon2);
                                                                        return(
                                                                            <div className="custom-control custom-checkbox" key={addon2.CUSTOMDATID}>
                                                                                <input type={addon.TYPE=='INC'?'checkbox':'radio'} className="custom-control-input" value={`${addon.CUSTOMID}~${addon2.CUSTOMDATID}~${addon2.DEFAULT}~${addon2.RATE}~${addon2.TAXID}~${addon2.TAXPERCENT}~${addon2.CESSPERCENT}`} name={`chkcustomdat_${addon.CUSTOMID}[]`} id={`chkcustomdat_${addon.CUSTOMID}~${addon2.CUSTOMDATID}`} defaultChecked={addon2.DEFAULT=='Y'?true:false} />
                                                                                <label className="custom-control-label" htmlFor={`chkcustomdat_${addon.CUSTOMID}~${addon2.CUSTOMDATID}`}>
                                                                                    <img src={`/assets/img/${addon2.TYPE}.svg`} style={{ float: "left" }} /> {addon2.CUSTOMDATNAME}
                                                                                    <div className="text-price">&#8377; {addon2.RATE}</div>
                                                                                </label>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }   
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div className="form-button-group">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <button type="button" className="btn btn-secondary btn-block btn-lg" data-dismiss="modal">CLOSE</button>
                                                    </div>
                                                    <div className="col-6">
                                                        <button type="button" className="btn btn-primary btn-block btn-lg" data-dismiss="modal" onClick={()=>{this.handleClickGetItemCustomSelected(this.state.id,inputTAGS)}}>ADD</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal fade dialogbox" id="ModalCartExist" data-backdrop="static" tabIndex="-1" role="dialog">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">&nbsp;</h5>
                                        </div>
                                        <div className="modal-body"> 
                                            Repeat last used customization? 
                                        </div>
                                        <div className="modal-footer">
                                            <div className="btn-inline"> 
                                                <button type="button" className="btn btn-text-secondary" data-dismiss="modal" onClick={()=>{this.handleClickGetCustom(this.state.id)}}>I'll Choose</button>
                                                <button type="button" className="btn btn-text-primary" data-dismiss="modal" onClick={()=>{this.handleClickGetCustomRepeat(this.state.id,cartCount)}}>Repeat Last</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal fade dialogbox" id="ModalMultiCartExist" data-backdrop="static" tabIndex="-1" role="dialog">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">&nbsp;</h5>
                                        </div>
                                        <div className="modal-body"> 
                                            This item has multiple customiszations added. Proceed to cart to remove item?  
                                        </div>
                                        <div className="modal-footer">
                                            <div className="btn-inline"> 
                                                <Link to="/cart" className="btn btn-text-success" data-dismiss="modal">Yes</Link>
                                                <button type="button" className="btn btn-text-danger" data-dismiss="modal">No</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
              </div>
            );
    }
}

export default SpecialDishItem;


// WEBPACK FOOTER //
// ./src/components/SpecialDishItem.js